import { ReceiptSettingsStore } from '../../../factories/database/receipt-settings-store'
import { RegisterManager } from '../../../managers/register-manager'
import { TrainingModeManager } from '../../../managers/training-mode-manager'
import { $log } from '../../../ng-compat/imports'

/**
 * Controller Class for ReceiptSelectionPopoverController.
 */
export class ReceiptSelectionPopoverController {
  public defaultReceipt: $TSFixMe

  /**
   * Collection of receipt templates
   */
  public receiptTemplates: $TSFixMe[] = []

  constructor(
    public close: $TSFixMe,
    receiptSettingsStore: ReceiptSettingsStore,
    public trainingModeManager: TrainingModeManager,
    registerManager: RegisterManager
  ) {
    'ngInject'

    receiptSettingsStore
      .all()
      .then(receipts => {
        receipts.forEach((receipt: $TSFixMe) => {
          const receiptInfo = {
            name: receipt.name,
            id: receipt.id,
          }
          if (
            receiptInfo.id ===
            registerManager.getActiveRegister().receipt_template_id
          ) {
            this.defaultReceipt = receiptInfo
          } else {
            this.receiptTemplates.push(receiptInfo)
          }
        })
      })
      .catch((error: $TSFixMe) => {
        $log.warn(
          'Failed to retrieve templates from receiptTemplates store',
          error
        )
      })
  }

  /**
   * Trigger printing of selected receipt
   *
   * @method selectReceipt
   */
  public selectReceipt(selectedReceipt: $TSFixMe) {
    this.close({
      selectedReceipt,
      defaultTemplate: selectedReceipt === this.defaultReceipt,
    })
  }
}
